import {head} from 'ramda';
import {isNilOrEmpty} from 'ramda-adjunct';

import {PersonRequestBody} from '@dms/api/customer';

import {getEmailsRequestBody} from './getEmailsRequestBody';

/**
 * Turns the values of a person form into the request body. Leaves out the empty e-mail rows and
 * the empty first phone number and identity card row. `emailFormIndexes` keeps the form row of
 * each sent e-mail.
 */
export const getContactRequestBody = (person: PersonRequestBody) => {
  const {emails, formIndexes} = getEmailsRequestBody(person.emails);

  return {
    personRequestBody: {
      ...person,
      phoneNumbers: isNilOrEmpty(head(person.phoneNumbers ?? [])?.phoneNumber?.number)
        ? []
        : person.phoneNumbers,
      emails,
      identityCards: isNilOrEmpty(head(person.identityCards ?? [])?.cardData?.cardNumber)
        ? []
        : person.identityCards,
    },
    emailFormIndexes: formIndexes,
  };
};
